<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <div class="d-flex align-center justify-center">
      <page-header>
        数据和管理
      </page-header>
      <v-spacer />
    </div>
    <v-item-group
      v-model="titleGroup"
      class="d-flex flex-wrap mt-4"
      mandatory
    >
      <div
        v-for="item in titleList"
        :key="item.id"
      >
        <v-item
          v-slot="{ active, toggle }"
        >
          <v-btn
            :class="active ? 'amber lighten-4' : ''"
            class="pa-4 mr-4 my-2"
            elevation="0"
            large
            outlined
            @click="toggle"
          >
            <div
              class="d-flex justify-center align-center"
            >
              <div>
                {{ item.type }}
              </div>
            </div>
          </v-btn>
        </v-item>
      </div>
    </v-item-group>
    <div v-if="tabType === '宣传物料'">
      <div class="d-flex">
        <v-chip-group
          v-model="selectedTag"
          active-class="deep-purple--text text--accent-4"
          multiple
        >
          <v-chip
            v-for="tag in allTagList"
            :key="tag"
          >
            {{ tag }}
          </v-chip>
        </v-chip-group>
        <v-spacer />
        <v-btn
          class="amber lighten-4"
          outlined
          small
          @click="newTag = true"
        >
          新建TAG
        </v-btn>
      </div>
      <div
        style="display: grid;
             grid-template-columns: repeat(3,minmax(0,1fr));
             grid-gap: 12px"
      >
        <v-card
          class="pa-4 d-flex align-center justify-center"
          color="#eee"
          outlined
          width="100%"
          @click="newPublicizeDialog = true"
        >
          <v-icon large>
            mdi-plus
          </v-icon>
        </v-card>
        <v-card
          v-for="item in imgList"
          :key="item.id"
          class="pa-4"
          outlined
          width="100%"
          @click="editActivity(item)"
        >
          <div class="d-flex">
            <div class="pa-2">
              <v-img
                :src="img"
                height="96"
                width="96"
              />
            </div>

            <v-chip-group>
              <v-chip
                v-for="(tag,index) in item.tag"
                :key="index"
              >
                {{ tag }}
              </v-chip>
            </v-chip-group>
          </div>
        </v-card>
      </div>
      <v-dialog
        v-model="newTag"
        max-width="400px"
      >
        <v-card class="pa-4">
          <div class="d-flex align-center justify-center">
            <div class="text-h4 font-weight-bold">
              新增Tag
            </div>
            <v-spacer />
            <div>
              <v-btn
                icon
                @click="newTag = false"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </div>
          <div
            class="d-flex align-center justify-center mt-8"
          >
            <div
              class="text-h5 font-weight-bold"
              style="width: 150px"
            >
              Tag:
            </div>
            <v-text-field
              v-model="tagName"
              dense
              hide-details
              outlined
            />
          </div>
          <v-btn
            class="amber lighten-4"
            outlined
            @click="saveTag"
          >
            保存
          </v-btn>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="newPublicizeDialog"
        max-width="400px"
      >
        <v-card class="pa-4">
          <div class="d-flex align-center justify-center">
            <div class="text-h4 font-weight-bold">
              新增宣传物料
            </div>
            <v-spacer />
            <div>
              <v-btn
                icon
                @click="newPublicizeDialog = false"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </div>
          <div class="d-flex align-center justify-center mt-8">
            <v-card
              color="#c0c0c0"
              elevation="0"
              height="150px"
              style="position: relative"
              width="150px"
            >
              <div
                style="position:absolute;
                top: 0px;left: 0px;right: 0px;bottom:0px;
                margin:auto;border-radius: 12px"
              >
                <v-img
                  :src="currentImg"
                  style="border-radius: 12px"
                />
              </div>
              <v-file-input
                accept="image/*"
                class="mt-2"
                counter
                dense
                height="150px"
                outlined
                style="opacity: 0;cursor: pointer"
                width="150px"
                @change="processFile"
              />
            </v-card>
          </div>
          <div
            class="d-flex align-center justify-center mt-8"
          >
            <div
              class="text-h5 font-weight-bold"
              style="width: 150px"
            >
              请选择TAG:
            </div>
            <v-select
              v-model="needAddTag"
              :items="allTagList"
              dense
              hide-details
              multiple
              outlined
            />
          </div>
          <div class="d-flex align-center justify-center mt-8">
            <v-btn
              class="amber lighten-4"
              outlined
              width="100%"
              @click="newPublicize"
            >
              保存
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <div v-else-if="tabType === '活动方案'">
      <branding-plan />
    </div>
    <div v-else>
      <branding-campaign />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import BrandingPlan from '@/views/AadenPages/branding/fragments/BrandingPlan.vue'
import BrandingCampaign from '@/views/AadenPages/branding/fragments/BrandingCampaign.vue'

export default {
  name: 'BrandingMarketing',
  components: { BrandingCampaign, BrandingPlan, PageHeader },
  data () {
    return {
      needAddTag: [],
      currentImg: null,
      newPublicizeDialog: false,
      img: require('@/assets/pricing.jpg'),
      imgList: [{ id: 1, tag: ['经济实惠', '火热爆款'] }, { id: 2, tag: ['经典原味'] }],
      tagName: '',
      newTag: false,
      selectedTag: null,
      allTagList: ['经济实惠', '火热爆款', '经典原味'],
      tabType: null,
      titleGroup: null,
      titleList: [{ value: 'publicize', type: '宣传物料' }, { value: 'plan', type: '活动方案' }, { value: 'campaign', type: '宣传campaign' }]
    }
  },
  watch: {
    newPublicizeDialog (val) {
      if (!val) {
        this.currentImg = null
        this.needAddTag = []
      }
    },
    selectedTag (val) {
      const res = []
      for (const tagIndex of val) {
        res.push(this.allTagList[tagIndex])
      }
      console.log(res, 'res')
      const result = this.imgList.filter(it => it.tag === res)
      console.log(result, 'result')
    },
    titleGroup (val) {
      this.tabType = this.titleList[val].type
    }
  },
  methods: {
    async processFile (event) {
      this.currentImg = URL.createObjectURL(event)
    },
    newPublicize () {},
    editActivity (item) {
      this.currentImg = this.img
      this.needAddTag = item.tag
      this.newPublicizeDialog = true
      console.log(item, 'item')
    },
    saveTag () {
      this.allTagList.push(this.tagName)
      this.newTag = false
    }
  }
}
</script>

<style scoped>

</style>
